<div class="contact-card">
  <h5 class="title yellow-cfa-languedoc-bg p-2 mb-0">
    <span class="mb-0">Restons en contact !</span>
    <span class="title__icon" (click)="toggleCard()">{{displayCard ? '-' : '+'}}</span>
  </h5>
  <form *ngIf="displayCard">
    <div class="red-cfa-languedoc-bg white px-2">
      <ng-container *ngIf="!isSent; else confirmation">
        <div class="tick-line py-2">
          <img src="assets/img/tick-box.png" class="tick-line__img">
          <div class="tick-line__text">
            être informé en premier des propositions de postes en alternance
          </div>
        </div>
        <div class="tick-line pb-2">
          <img src="assets/img/tick-box.png" class="tick-line__img">
          <div class="tick-line__text">
            m’entretenir avec un enseignant pour une candidature
          </div>
        </div>

        <div class="form-line py-2">
          <div class="form-line__label">
            TEL
          </div>
          <input class="form-line__field" [(ngModel)]="coordonneesEtudiantForm.telephone" name="telephone">
        </div>
        <div class="form-line pb-2">
          <div class="form-line__label">
            EMAIL
          </div>
          <input class="form-line__field" [(ngModel)]="coordonneesEtudiantForm.email" name="email">
        </div>

        <span *ngIf="error" class="yellow-cfa-languedoc fs-14 py-2">{{error}}</span>

        <button class="yellow-cfa-languedoc-bg" (click)="verifForm()">
          ENVOYER
        </button>
      </ng-container>

      <ng-template #confirmation>
        <div class="tick-line py-2">
          <img src="assets/img/tick-box.png" class="tick-line__img">
          <div class="tick-line__text">
            coordonnées bien envoyées !
          </div>
        </div>
      </ng-template>
    </div>
  </form>
</div>
